export default {
  namespaced: true,

  state: {
    words: []
  },

  mutations: {
    addWord: (state, word) => {
      state.words.find(w => w.name === word.name) ? null : state.words.push(word)
    }
  }

}